import React, { useState, useEffect } from "react";
import {
  Paper,
  TextField,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Skeleton,
  Box,
} from "@mui/material";
import Template from "../Generico/Template";
import TituloPrincipal from "../Generico/TituloPrincipal";
import AuthService from "../../AuthService";

import { useSnackbar } from "notistack";

const Prompt = () => {
  const [value, setValue] = useState("");
  const [originalValue, setOriginalValue] = useState("");
  const [dialogOpen, setDialogOpen] = useState(false);
  const [skeleton, setSkeleton] = useState(true);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    const fetchPrompt = async () => {
      const service = new AuthService();
      setSkeleton(true);
      try {
        const res = await service.get("/prompt/1");
        setValue(res.prompt);
        setOriginalValue(res.prompt);
      } catch (error) {
        enqueueSnackbar("Erro ao carregar o prompt", { variant: "error" });
      } finally {
        setSkeleton(false);
      }
    };

    fetchPrompt();
    //eslint-disable-next-line
  }, []);

  const handleChange = (e) => {
    setValue(e.target.value);
  };

  const handleReset = () => {
    setValue(originalValue);
  };

  const handleSaveClick = () => {
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const handleConfirmSave = async () => {
    try {
      const service = new AuthService();
      const body = {
        id: 1,
        enable: true,
        prompt: value,
      };

      const res = await service.post("/prompt", body);
      setValue(res.prompt);
      setOriginalValue(res.prompt);
      setDialogOpen(false);

      enqueueSnackbar("Prompt salvo com sucesso!", { variant: "success" });
    } catch (error) {
      console.error("Erro ao salvar o prompt:", error);
      enqueueSnackbar("Erro ao salvar o prompt.", { variant: "error" });
    }
  };

  return (
    <Template documentTitle="Configuração do Prompt do bot de pedidos">
      <TituloPrincipal
        title="Configuração do Prompt"
        subTitle="Configure o Prompt do bot de pedidos"
      />
      <Paper
        elevation={3}
        sx={{
          marginTop: "1rem",
          padding: 2,
          maxHeight: "90vh",
          overflow: "auto",
        }}
      >
        {skeleton ? (
          <Skeleton variant="rectangular" height="80vh" />
        ) : (
          <TextField
            multiline
            minRows={25}
            variant="standard"
            value={value || ""}
            onChange={handleChange}
            fullWidth
          />
        )}
      </Paper>
      <Box
        sx={{
          display: "flex",
          gap: 2,
          marginTop: "1rem",
          justifyContent: "flex-end",
        }}
      >
        <Button variant="outlined" color="secondary" onClick={handleReset}>
          Cancelar
        </Button>
        <Button variant="contained" color="primary" onClick={handleSaveClick}>
          Salvar
        </Button>
      </Box>
      <Dialog open={dialogOpen} onClose={handleDialogClose}>
        <DialogTitle>Confirmar alterações</DialogTitle>
        <DialogContent>
          Tem certeza que deseja salvar as alterações no prompt?
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} color="primary">
            Cancelar
          </Button>
          <Button
            onClick={handleConfirmSave}
            color="primary"
            variant="contained"
          >
            Sim, salvar
          </Button>
        </DialogActions>
      </Dialog>
    </Template>
  );
};

export default Prompt;
